import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {AccessRoleSearchModel} from "../access-role-search.model";
import {AccessRoleSearchPageComponent} from "../access-role-search-page/access-role-search-page.component";
import {AccessRoleEditPageComponent} from "../access-role-edit-page/access-role-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";

@Component({
    selector: "wbo-access-role-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(AccessRoleSingleSelectEditControlComponent),
        provideSearchModel(AccessRoleSearchModel)
    ]
})
export class AccessRoleSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<AccessRoleSearchModel> {
    constructor(model: AccessRoleSearchModel, injector: Injector) {
        super(model, injector, "accessRoleId", "name");

        this.extendedSearchComponent = AccessRoleSearchPageComponent;
        this.extendedEditComponent = AccessRoleEditPageComponent;
    }
}
